import { render } from "./ComponentNeedsSurvey.vue?vue&type=template&id=71da40bd&scoped=true"
import script from "./ComponentNeedsSurvey.vue?vue&type=script&lang=js"
export * from "./ComponentNeedsSurvey.vue?vue&type=script&lang=js"

import "./ComponentNeedsSurvey.vue?vue&type=style&index=0&id=71da40bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71da40bd"]])

export default __exports__